import {types} from 'mobx-state-tree';

export const VariantImage = types.map(types.string);

export type VariantImageType = typeof VariantImage.Type;

export const Agent = types.model('Agent', {
  id: types.identifierNumber,
  email: types.string,
  name: types.string,
  phone: types.string,
  title: types.string
});

export type AgentType = typeof Agent.Type;

export const Market = types.model('Market', {
  listingUrl: types.maybe(types.string),
  state: types.string,
  market_id: types.maybe(types.number),
  id: types.maybe(types.number)
});

export const TemplateContent = types.model('TemplateContent', {
  renderedText: types.string,
  text: types.string,
  language: types.model({
    code: types.string,
    name: types.string
  })
});

export type TemplateContentType = typeof TemplateContent.Type;

export const Template = types.model('Template', {
  id: types.identifierNumber,
  code: types.string,
  name: types.string,
  contents: types.array(TemplateContent)
});

export type MarketType = typeof Market.Type;

export type ListingVariantModelViews = {
  previewImageUrl?: string;
  descriptionContent?: TemplateContentType;
  titleContent?: TemplateContentType;
};

const ListingVariantModel = types
  .model('ListingVariant', {
    id: types.identifierNumber,
    address: types.string,
    agent: Agent,
    area: types.number,
    areaUnit: types.string,
    baths: types.optional(types.number, 0),
    beds: types.optional(types.number, 0),
    dailyCurrency: types.string,
    dailyRate: types.number,
    description: types.maybe(types.string),
    images: types.array(VariantImage),
    latitude: types.number,
    longitude: types.number,
    markets: types.array(Market),
    monthlyCurrency: types.string,
    monthlyRate: types.number,
    name: types.maybe(types.string),
    type: types.string,
    marketRequest: types.maybe(types.string),
    parking: types.maybe(types.string),
    descriptionTemplate: types.maybe(Template),
    titleTemplate: types.maybe(Template)
  })
  .views<ListingVariantModelViews>(self => ({
    get previewImageUrl() {
      const {images} = self;
      return images && images.length > 0 ? images[0].get('url') : undefined;
    },
    get descriptionContent() {
      const {descriptionTemplate} = self;
      if (descriptionTemplate) {
        const {contents} = descriptionTemplate;
        if (contents && contents.length > 0) {
          return contents[0];
        }
      }
      return undefined;
    },
    get titleContent() {
      const {titleTemplate} = self;
      if (titleTemplate) {
        const {contents} = titleTemplate;
        if (contents && contents.length > 0) {
          return contents[0];
        }
      }
      return undefined;
    }
  }));

export type ListingVariantModelType = typeof ListingVariantModel.Type;

export default ListingVariantModel;



// WEBPACK FOOTER //
// ./src/models/ListingVariantModel/ListingVariantModel.ts